<template>
  <div class="login-card-disclaimer">
    <h2 v-if="text">{{ text }}</h2>

    <slot v-if="$slots.default || linkText">
      <h3>
        <a
          href="javascript:;"
          title="Utilizar o código reserva"
          @click.prevent="$emit('handle-disclaimer')"
        >
          {{ linkText }}
        </a>
      </h3>
    </slot>
  </div>
</template>

<script>
export default {
  name: "LoginCardDisclaimer",

  props: {
    text: {
      type: String,
      default: ''
    },

    linkText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.login-card-disclaimer
  font-size 14px
  line-height 20px
  text-align center
</style>
